import { AddonController } from "./components/addons.js";
import { MarketController } from "./components/market.js";
import { RentalController } from "./components/rental.js";
import { ScheduledRentalController } from "./components/scheduledrental.js";
import { StationController } from "./components/station.js";
import { TripActivityController } from "./components/tripactivity.js";
import { VehicleCheckout } from "./components/vehicleCheckout.js";
import { SubscriptionsController } from "./components/subscriptions.js";

export class CarsharingController {
  constructor() {
    this.addonController = new AddonController();
    this.marketController = new MarketController();
    this.rentalController = new RentalController();
    this.scheduledRentalController = new ScheduledRentalController();
    this.stationController = new StationController();
    this.tripActivityController = new TripActivityController();
    this.vehicleCheckoutController = new VehicleCheckout();
    this.subscriptionsController = new SubscriptionsController();
  }

  init() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  getMarkets(overrideQueryParams = {}) {
    return this.marketController.getMarkets(overrideQueryParams);
  }

  getMarket(queryParams) {
    return this.marketController.getMarket(queryParams);
  }

  getStations(queryParams) {
    return this.stationController.getStations(queryParams);
  }

  getAvailableStartDates(queryParams) {
    return this.scheduledRentalController.getAvailableStartDates(queryParams);
  }

  getAvailableStartTimes(queryParams) {
    return this.scheduledRentalController.getAvailableStartTimes(queryParams);
  }

  getServiceAvailableStartDates(queryParams) {
    return this.scheduledRentalController.getServiceAvailableStartDates(
      queryParams
    );
  }

  getServiceAvailableStartTimes(queryParams) {
    return this.scheduledRentalController.getServiceAvailableStartTimes(
      queryParams
    );
  }

  getAvailableEndDates(queryParams) {
    return this.scheduledRentalController.getAvailableEndDates(queryParams);
  }

  getAvailableEndTimes(queryParams) {
    return this.scheduledRentalController.getAvailableEndTimes(queryParams);
  }

  getAvailableVehicleTypes(queryParams) {
    return this.scheduledRentalController.getAvailableVehicleTypes(queryParams);
  }

  scheduleRental(params) {
    return this.scheduledRentalController.scheduleRental(params);
  }

  cancelScheduledRental(queryParams) {
    return this.scheduledRentalController.cancelScheduledRental(queryParams);
  }

  getTrips(queryParams) {
    return this.tripActivityController.getTrips(queryParams);
  }

  getRental(queryParams) {
    return this.rentalController.getRental(queryParams);
  }

  getRental(overrideQueryParams = {}) {
    return this.rentalController.getRental(overrideQueryParams);
  }

  getPolicyDocuments() {
    return this.vehicleCheckoutController.getPolicyDocuments();
  }

  getSupportPhoneNumber() {
    return this.vehicleCheckoutController.getSupportPhoneNumber();
  }

  associateCustomerToBusiness(queryParams) {
    return this.vehicleCheckoutController.associateCustomerToBusiness(
      queryParams
    );
  }

  getVehicleList(queryParams) {
    return this.vehicleCheckoutController.getVehicleList(queryParams);
  }

  getRentalInfo(queryParams) {
    return this.vehicleCheckoutController.getRentalInfo(queryParams);
  }

  associateVehicleDriver(queryParams) {
    return this.vehicleCheckoutController.associateVehicleDriver(queryParams);
  }

  getJumioAuthLink(queryParams) {
    return this.vehicleCheckoutController.getJumioAuthLink(queryParams);
  }

  getJumioAuthStatus(queryParams) {
    return this.vehicleCheckoutController.getJumioAuthStatus(queryParams);
  }

  getInspectionReport(queryParams) {
    return this.vehicleCheckoutController.getInspectionReport(queryParams);
  }

  getRentalAgreement(queryParams) {
    return this.vehicleCheckoutController.getRentalAgreement(queryParams);
  }

  signInspectionReport(queryParams) {
    return this.vehicleCheckoutController.signInspectionReport(queryParams);
  }

  signRentalAgreement(queryParams) {
    return this.vehicleCheckoutController.signRentalAgreement(queryParams);
  }

  getCustomerRentalInfo() {
    return this.vehicleCheckoutController.getCustomerRentalInfo();
  }

  updateDoorStatus(queryParams) {
    return this.vehicleCheckoutController.updateDoorStatus(queryParams);
  }

  createCarSharingRental(queryParams) {
    return this.vehicleCheckoutController.createCarSharingRental(queryParams);
  }

  getCarsharingRental(queryParams) {
    return this.vehicleCheckoutController.getCarsharingRental(queryParams);
  }

  endCarSharingRental(queryParams) {
    return this.vehicleCheckoutController.endCarSharingRental(queryParams);
  }

  removeVehicleFromFleet(queryParams) {
    return this.vehicleCheckoutController.removeVehicleFromFleet(queryParams);
  }

  postRating(queryParams) {
    return this.vehicleCheckoutController.postRating(queryParams);
  }

  getVehicleTypeLeasingEntities(queryParams) {
    return this.subscriptionsController.getVehicleTypeLeasingEntities(
      queryParams
    );
  }

  getVTLEDetails(id) {
    return this.subscriptionsController.getVTLEDetails(id);
  }

  getStationVehicleTypes(queryParams) {
    return this.subscriptionsController.getStationVehicleTypes(queryParams);
  }

  getVehicleType(id) {
    return this.subscriptionsController.getVehicleType(id);
  }

  createContract(params) {
    return this.scheduledRentalController.createScheduledRentalContract(params);
  }

  getSubscription(params) {
    return this.subscriptionsController.getSubscription(params);
  }

  getSubscriptionProviderConfig(queryParams) {
    return this.subscriptionsController.getSubscriptionProviderConfig(
      queryParams
    );
  }

  getAddons(params) {
    return this.addonController.getAddons(params);
  }

  getAddon(params) {
    return this.addonController.getAddon(params);
  }

  getAddonTypes(params) {
    return this.addonController.getAddonTypes(params);
  }

  getAddonType(params) {
    return this.addonController.getAddonType(params);
  }

  getLeasingAddonsRate(params) {
    return this.addonController.getLeasingAddonsRate(params);
  }
}
